
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.339 2.86a6 6 0 00-9.03 7.885m9.03-7.885a6 6 0 11-9.03 7.885m9.03-7.885l-9.03 7.885","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    